<div class="preloader-area">
    <div class="spinner">
        <div class="inner">
            <img src="assets/img/favicon.png">
            <!-- <div class="disc"></div>
            <div class="disc"></div>
            <div class="disc"></div> -->
        </div>
    </div>
</div>